import React, { useState } from 'react';
import DatePicker  from 'react-datepicker';

import { Modal, Col, Row, Form } from 'react-bootstrap';

import IcX from '../../components/Svg/IcX';

import styleButton from '../Button/Button.module.css'
import styles from './style.module.css'
import * as yup from 'yup';

const ModalReceiptCancel = props => {
  const {show, onHide, reload, setReload, ...other} = props

  const [formError, setFormError] = useState('')

  const closeModal = () => {
    setFormError(' ')
    onHide()
  }


  return(
    <Modal show={show} onHide={onHide}>
      <Modal.Header className="border">
        <Modal.Title>Cancelar boleto?</Modal.Title>
        <button className={styles.closeModal} onClick={closeModal}>
          <IcX/>
        </button>
      </Modal.Header>
      <Modal.Body className="bgWhite">
        <Row>
          <Col>
            <p>Ao cancelar este boleto, o valor referente irá ser adicionado como débito na conta do formando e da sua respectiva turma. Deseja continuar?</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button onClick={closeModal} className={styleButton.button_ghost}>Não</button>
        <button onClick={closeModal} className={`ml-2 ${styleButton.button_primary}`}>Sim</button> 
      </Modal.Footer>
    </Modal>
  )
}

export default ModalReceiptCancel 